export function filterMenuByAccess(items, userInfo) {
  const permissions = userInfo?.permissions || []
  const userRole = userInfo?.role
  const hasWildcard =
    permissions.includes("*") || userRole === "network-admin"

  return (items || []).reduce((acc, item) => {
    if (item.dontShowFor && item.dontShowFor.includes(userRole)) {
      return acc
    }

    if (item.children) {
      const children = filterMenuByAccess(item.children, userInfo)
      if (children.length > 0) {
        acc.push({ ...item, children })
      }
      return acc
    }

    if (hasWildcard) {
      acc.push(item)
      return acc
    }

    if (item.access?.some((entry) => permissions.includes(entry.value))) {
      acc.push(item)
    }

    return acc
  }, [])
}

export function toAntdMenuItems(items) {
  return (items || []).map((item) => {
    if (item.children) {
      return {
        key: item.title,
        icon: item.icon,
        label: item.title,
        children: item.children.map((child) => ({
          key: child.Link,
          icon: child.icon,
          label: child.title,
        })),
      }
    }

    return {
      key: item.Link,
      icon: item.icon,
      label: item.title,
    }
  })
}

const ROUTE_ALIASES = [
  ["/device-management", "/devices"],
  ["/patch-management", "/patches"],
  ["/app-management/", "/app-management"],
  ["/logs/", "/all-logs"],
  ["/edit-schedule", "/schedules"],
  ["/add-schedule", "/schedules"],
  ["/edit/group-devices", "/group-devices"],
  ["/add/group-devices", "/group-devices"],
  ["/group-devices-lists", "/group-devices"],
  ["/edit-app-bundles", "/app-bundles"],
  ["/add-app-bundles", "/app-bundles"],
  ["/edit-customtask", "/custom-task"],
  ["/add-customtask", "/custom-task"],
  ["/edit-script", "/scripts"],
  ["/add-script", "/scripts"],
  ["/roles/", "/roles"],
  ["/global-patches/", "/global-patches"],
  ["/patch-reports", "/patch-reports"],
  ["/software-reports", "/software-reports"],
  ["/online-devices", "/devices"],
  ["/offline-devices", "/devices"],
  ["/away-devices", "/devices"],
  ["/catalog-policy", "/catalog-policy"],
  ["/app-control", "/app-control"],
  ["/inactivity-notification-settings", "/inactivity-notification-settings"],
  ["/desktop-broadcasts", "/desktop-broadcasts"],
  ["/training", "/training"],
  ["/training/certificate", "/training"],
  ["/deployments", "/schedules"],
  ["/agent-health", "/devices"],
  ["/battery-report", "/battery-report"],
  ["/os-updates", "/patches"],
  ["/wsus-status", "/wsus-status"],
  ["/encryption-keys", "/security-policies"],
  ["/laps", "/security-policies"],
  ["/compliance-policies", "/compliance-policies"],
  ["/security-templates", "/security-templates"],
  ["/help-desk", "/help-desk"],
]

const collectLinks = (items, acc = []) => {
  ;(items || []).forEach((item) => {
    if (item.Link) acc.push(item.Link)
    if (item.children) collectLinks(item.children, acc)
  })
  return acc
}

export function findSelectedKeys(items, pathname) {
  const links = collectLinks(items)
  if (links.includes(pathname)) return [pathname]

  const alias = ROUTE_ALIASES.find(([prefix]) => pathname.startsWith(prefix))
  if (alias && links.includes(alias[1])) return [alias[1]]

  const prefixMatch = links
    .filter((link) => link && link !== "/" && pathname.startsWith(link))
    .sort((a, b) => b.length - a.length)[0]

  return [prefixMatch || pathname]
}

export function findOpenKeys(items, pathname) {
  const selected = findSelectedKeys(items, pathname)[0]
  return (items || [])
    .filter(
      (item) =>
        item.children &&
        item.children.some(
          (child) =>
            child.Link &&
            (selected === child.Link || selected?.startsWith(child.Link))
        )
    )
    .map((item) => item.title)
}
